import ReportsPreviewModalView from "../../reports/reports-preview.html";
import DocumentsImportDocumentModalView from "./DocumentsImportDocumentModal.html";


angular.module("events")
    .controller("EventsDocumentsListCtrl", ['event', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', '$http', '$window', 'uiGridConstants', 'eventService', 'Upload', 'logService',
        function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, $http, $window, uiGridConstants, eventService, Upload, logService) {

            $rootScope.title = $filter('translate')('events.title') + " - " + $filter('translate')('events.documents.documents');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.documents.documents') }
            ];
            $scope.classSize = "col-lg-12";

            function isDefinedAndNotNull(val) {
                return angular.isDefined(val) && val !== null;
            }
            function isDefinedAndNotNullOrEmpty(val) {
                return angular.isDefined(val) && val !== null && val !== "";
            }

            $scope.event = event;
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                { title: $filter('translate')('events.documents.documents') }
            ];
            $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.documents.documents');

            $scope.is_template = $stateParams.is_template == 'true';

            var options = {
                event_id: $stateParams.id,
                has_variables: true,
                no_program_act_config: true
            };

            Restangular.all('DocumentsTypes').getList(options).then(function (data) {
                $scope.documentTypes = data;

                $scope.loadTemplateDocuments();
                
                angular.forEach($scope.documentTypes, function (documentType) {
                    var options = {
                        code: documentType.code
                    };
                    Restangular.all('Documents/GetDocumentsByDocumentTypeCode').getList(options).then(function (data) {
                        documentType.documents = data;
                    });
                });
            });

            $scope.configure = function (document) {

                $scope.$modalInstance = $uibModal.open({
                    animation: true,
                    template: ReportsPreviewModalView,
                    controller: 'ReportsPreviewCtrl',
                    size: 'lg',
                    resolve: {
                        document: function () {
                            return document;
                        },/*
                        event: function () {
                            return event;
                        }*/
                        entity_type: function () { return "events"; },
                        entity_type_id: function () { return event.id; }
                    }

                });

                $scope.$modalInstance.result.then(function (data) {
                    let modified = [];

                    //añadimos info de parametros
                    angular.forEach(data, function (parameter) {
                        if(typeof parameter.values !== "undefined") {
                            parameter.entity_type = "events";
                            parameter.entity_type_id = $scope.event.id;
                            parameter.document_id = document.id;
                            if (parameter.name == 'JasperParameter' && parameter.values !=null) {
                                let values = [];
                                var val = {
                                    language_id: 1,
                                    value: parameter.values
                                };
                                values.push(val);
                                parameter.values = values;
                            }
                            modified.push(parameter);
                        }
                    });

                    //guardar parametros para el evento en cuestion
                    Restangular.all('DocumentsConfig').post(modified).then(function (data) {
                        logService.debug(data);
                    });

                });
            };

            // Importación de archivos 
            $scope.importDocument = function (documentTypeId) {
                $scope.$modalInstance = $uibModal.open({
                    animation: true,
                    template: DocumentsImportDocumentModalView,
                    size: "lg",
                    controller: "DocumentsImportDocumentModalCtrl",
                    scope: $scope,
                    resolve: {
                        documentTypeId: function () {
                            return documentTypeId;
                        },
                    },
                });
            }

            $scope.loadTemplateDocuments = function () {
                Restangular.all("folders").customGET("getTemplateFolders", { event_id : $stateParams.id } ).then(function (res) {
                    let allTemplateFiles = res;
                    $scope.documentTypes.forEach(function (documentType) {
                        let templateFiles = allTemplateFiles.filter(f => f.DocumentTypeId == documentType.id);
                        documentType.templateFiles = null;
                        documentType.templateFiles = templateFiles;
                        if (templateFiles.length > 0) {
                            logService.debug(templateFiles);
                        }
                    });
                });
            };

            $scope.download = function (file) {
                modalService.confirm({
                    title: $filter('translate')('events.documents.download_file'),
                    message: $filter('translate')('events.documents.download_file_message') + " " + file.name + "?",
                    onAccept: function () {
                        let filePath = "/api/files/" + file.uid + "/download";
                        var link = document.createElement('a');
                        link.href = filePath;
                        link.download = `${file.name}`;
                        link.click();
                    }
                });
            };

            $scope.checkDelete = function (file) {
                modalService.confirm({
                    title: $filter('translate')('events.documents.delete'),
                    message: $filter('translate')('events.documents.delete_message') + " " + file.name + "?",
                    onAccept: function () {
                        Restangular.all("Files").customGET("removeFileTemplate", { fileId: file.id }).then(function (result) {
                            $scope.loadTemplateDocuments();
                            toastr.success($filter('translate')('events.documents.remove_success'));
                        });
                    }
                });
            };

            // Subimos el archivo
            let uploadFile = function (id) {
                $scope.replacementFile.upload = Upload.upload({
                    url: (window as any).CONFIG.api_url + `Files/replaceFile/${id}`,
                    data: { file: $scope.replacementFile, fileId: id },

                });

                $scope.replacementFile.upload.then(function (response) {
                    toastr.success($filter('translate')('events.documents.replace_success'));
                    $scope.loadTemplateDocuments();
                }, function (response) {
                    if (response.status > 0) {
                        let errorMsg = response.status + ': ' + response.data;
                        toastr.error("Ha ocurrido un error: " + errorMsg);
                    }
                })

                return true;
            };

            // Seleccionamos el archivo a subir 
            $scope.replaceFile = function (documentType, fileId) {
                $scope.replacementFile = null;
       
                $("#frmNewFile").click();
                $("#frmNewFile").change(function () {
                    var fileInput = document.querySelector('#frmNewFile') as HTMLInputElement;
                    var file = fileInput?.files?.[0];
                    if (file) {
                        documentType.templateFiles = [];
                        var fileReader = new FileReader();
                        /* 
                         * fileReader.onload = function (event) {
                            var src = event.target.result;
                            $scope.showImg = src;
                            if (!$scope.$$phase) $scope.$apply();
                        };
                        */
                        fileReader.readAsDataURL(file);
                        $scope.replacementFile = file;
                        uploadFile(fileId)
                    } else {
                        $scope.replacementFile = null;
                        return false;
                    }
                });
            };

        }])



    .controller("DocumentsImportDocumentModalCtrl", ['$scope', 'Restangular', 'documentTypeId', '$stateParams', 'logService',
        function ($scope, Restangular, documentTypeId, $stateParams, logService) {

        $scope.documentToAdd = {};
        $scope.selectFiles = [];

        Restangular.all('Files').getList({ documentTypeId: documentTypeId}).then(function (data) {
            $scope.selectFiles = data;
        });

        $scope.onSelect = function () {
            logService.debug($scope.documentToAdd.selected)
        }

        $scope.onAccept = function () {
            if ($scope.documentToAdd.selected.entity_type != "events" || $scope.documentToAdd.selected.entity_type_id != $stateParams.id) {
                $scope.documentToAdd.selected.entity_type = "events";
                $scope.documentToAdd.selected.entity_type_id = $stateParams.id;
            };

            Restangular.all('Files').customPOST($scope.documentToAdd.selected, "addFileToTemplates").then(function (result) {
                $scope.loadTemplateDocuments();
                $scope.$modalInstance.close();
            });
        }

        $scope.onCancel = function () {
            $scope.$modalInstance.dismiss('cancel');
        };

    }])
